exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-reference__send-button-wrapper {\n  display: flex;\n  justify-content: flex-end;\n}\n.edit-reference__select {\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/EditReference/EditReference.less
// module id = 1162
// module chunks = 0